var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13,26.014,2.161,15.161,0,13l2.161-2.161L13,0l2.161,2.156L5.85,11.472H29.932v3.056H5.85l9.316,9.32Z","transform":"translate(29.932 26.014) rotate(180)"}));
}

ArrowRight.defaultProps = {"width":"29.932","height":"26.014","viewBox":"0 0 29.932 26.014"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
